import { C as Collapsable, d as defineCustomElement$1 } from './collapsable.js';

const TtCollapsable = Collapsable;
const defineCustomElement = defineCustomElement$1;

export { TtCollapsable, defineCustomElement };
